var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 27,
  height: 27,
  viewBox: "0 0 27 27"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Rectangle_295",
  x: 0,
  y: 0,
  width: 27,
  height: 27,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.329
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_2197",
  "data-name": "Group 2197",
  transform: "translate(-833.5 415.5)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 833.5, -415.5)",
  filter: "url(#Rectangle_295)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_295-2",
  "data-name": "Rectangle 295",
  width: 24,
  height: 24,
  rx: 12,
  transform: "translate(1.5 0.5)",
  fill: "#fff1ad"
})), /*#__PURE__*/React.createElement("path", {
  id: "flash",
  d: "M125.707,5.687H121.02L125.365,0h-5.474l-5.132,8.531h3.551l-2.655,7.35Z",
  transform: "translate(726.534 -411.001)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "flash-2",
  "data-name": "flash",
  d: "M121.759,4.483h-3L121.54,0h-3.5l-3.281,6.724h2.581L114.759,13Z",
  transform: "translate(728.241 -409.508)",
  fill: "#fedb31"
}))));
export default __webpack_public_path__ + "static/media/express-active.9e4de6c1.svg";
export { SvgComponent as ReactComponent };